var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Inventory"},[_c('keep-alive',[(_vm.slugIsIn(['10', '11', '12', '16', '20', '23']))?_c('Particles'):_vm._e()],1),_vm._v(" "),(_vm.slugIsAfter('codec'))?_c('Codex'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c893120","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/Inventory.vue
// module id = null
// module chunks = 